<section class="signin">
    <div class="panel panel-hero">
        <div class="pre-head slide--right">
            <mat-icon svgIcon="logo-rebillia" class="custom-mat-icon ico-isologo-login"></mat-icon>
        </div>
        <div class="panel-header slide--right">
            <div class="panel-wrapper">
                <h1 class="typo headline semi-condensed fw300 label-title">Welcome back.</h1>
                <p class="typo body-1 semi-condensed fw300 label-subtitle">Enter your details below.</p>
            </div>
        </div>
        <div class="panel-main slide--right">
          <ul>
            <li class="row-form margin nomargin">
                <button (click)="_auth.loginWithGoogle()" color="primary" mat-flat-button class="size size1of1 custom-mat-button-primary rounded button-google" [disabled]="enableCreateCompanyButton" >
                    <mat-icon svgIcon="ico-google" class="custom-mat-icon ico-google"></mat-icon>Sign in with Google
                </button>
            </li>
          </ul>
            <form [formGroup]="form" class="panel-wrapper" novalidate>
                <ul>
                    <li class="row-divider">
                        <span class="typo note lowercase">Or</span>
                    </li>
                    <li class="row-form row-message">
                        <section class="message message-login" [@messageAnimation]='messageStatus'>
                            <div class="message-wrapper error">
                                <mat-icon svgIcon="ico-error" class="custom-mat-icon message-icon ico-size ico-sm"></mat-icon>
                                <p class="message-description"><strong>Whoops!</strong> Sorry, either your username or password isn't right. We can help you recover your password.</p>
                            </div>
                        </section>
                    </li>
                    <li class="row-form row__below__message" style="margin-bottom: 14px;">
                        <mat-form-field appearance="outline" class="size size1of1">
                            <mat-label>Email</mat-label>
                            <input matInput placeholder="Email" color="accent" formControlName="email" required >
                            <mat-error style="margin-top: 16px;"><error-messages [control]="form.get('email')"></error-messages></mat-error>
                        </mat-form-field>
                    </li>
                    <li class="row-form margin nomargin">
                        <mat-form-field appearance="outline" class="size size1of1">
                            <mat-label>Password</mat-label>
                            <input matInput type="password" placeholder="Password" color="accent" formControlName="password" required [type]="hide ? 'password' : 'text'">
                            <mat-icon matSuffix class="custom-mat-icon ico--is--disabled" (click)="hide = !hide">{{ hide ? 'visibility' : 'visibility_off' }}</mat-icon>
                            <mat-error style="margin-top: 16px;"><error-messages [control]="form.get('password')"></error-messages></mat-error>
                        </mat-form-field>
                    </li>
                    <li class="row-form row-nav align center">
                        <button mat-stroked-button (click)="onSubmit()" [disabled]="formSubmitted" ngClass="{'is--loading': formSubmitted}" color="primary" class="custom-mat-button button-signin size size1of1 rounded">Sign In</button>
                    </li>
                    <li class="row-form row-checkbox">
                        <mat-checkbox class="custom-mat-checkbox checkbox-simple-line" color="primary">Keep me logged in!</mat-checkbox>
                    </li>
                    <li class="row-form align center">
                        <nav class="login-links">
                            <ul>
                                <li class="nav-opt display inline-block">
                                    <a [routerLink]="['/login/signup']" routerLinkActive="router-link-active"  class="typo caption semi-condensed custom-mat-link active" *ngIf="!enableCreateCompanyButton">Need an account?</a>
                                    <a routerLinkActive="router-link-active"  class="typo caption semi-condensed custom-mat-link disable" *ngIf="enableCreateCompanyButton">Need an account?</a>
                                </li>
                                <li class="nav-opt display inline-block">
                                    <a [routerLink]="['/login/forgot']" routerLinkActive="router-link-active"  class="typo caption semi-condensed custom-mat-link active">Forgot Password?</a>
                                </li>
                            </ul>
                        </nav>
                    </li>
                    <li class="row-copyright">
                        <p class="typo note semi-condensed fw300 fluid-max max-200">By clicking sign in, you agree to Rebillia's
                            <strong class="typo fw600">Privacy Policy</strong> and <strong class="typo fw600">Terms of Use</strong>.</p>
                    </li>
                </ul>
            </form>
        </div>
    </div>
</section>
